import { makeSubmitData } from "api/makeApiRequestType/makeSubmitData";

export const deleteAccount = makeSubmitData<{ uid: string }>("deleteAccount");
